<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="InstitutionArg">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            机构费用设置
        </div>
        <div style="padding: 20px;"> 

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit"  @click="toggleModalEdit">编辑</el-button>
                    <el-button type="primary" :disabled="disabledMonthly"  @click="toggleModalMonthly">分月扣费设置</el-button>
                    <div style="float:right">
                        <el-select
                            v-model="status"
                                style="margin:0 10px;width:200px"
                            placeholder="请选择状态">
                            <el-option
                                v-for="item in statusValue"
                                :key="item[0]"
                                :label="item[1]"
                                :value="item[0]">
                            </el-option>
                        </el-select>
                        <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table
                    :data="tableData"
                    border
                    :height="th"
                    v-loading="loading"
                    highlight-current-row 
                    @row-click='rowClick'
                    style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="费用名称"
                        >
                    </el-table-column>
                    <el-table-column prop="price" label="价格(元/天)" v-if="dayShow"></el-table-column>
                    <el-table-column prop="priceMonth" label="价格(元/月)" v-if="monthShow"></el-table-column>
                    <el-table-column
                        prop="status"
                        label="状态"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.status==1">正常</span>
                            <span v-if="scope.row.status==2">废弃</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="扣费月份"
                        >
                        <template slot-scope="scope">
                            <el-tag type="success" effect="plain" v-if="scope.row.returnMonthList.length==0">全年扣费</el-tag>
                            <div v-else>
                                <el-popover
                                    placement="top-start"
                                    title="月份"
                                    width="200"
                                    trigger="hover">
                                    <el-tag type="danger" effect="plain" v-for="item in deWeightArr(scope.row.returnMonthList)" :key="item">{{monthly[item-1]}}月</el-tag>
                                    <el-tag slot="reference" effect="plain" >分月扣费</el-tag>
                                </el-popover>
                                
                            </div>
                        </template>
                    </el-table-column>
                    </el-table>
                </template>
            </div>
        </div>
        <!-- 分月扣费设置 -->
        <el-dialog title="分月扣费设置" :visible.sync="dialogMonthly" width="900px">
            <el-alert title="点击月份可勾选扣费月份，高亮为已选中，默认为全年扣费" type="error" style="margin-bottom: 20px;"> </el-alert>
            <el-checkbox-group v-model="monthList">
                <el-checkbox-button v-for="(item,i) in monthly" :label="i+1" :key="i">{{item}}月</el-checkbox-button>
            </el-checkbox-group>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogMonthly = false">取 消</el-button>
                <el-button type="primary" @click="monthSubmit">更 改</el-button>
            </div>
        </el-dialog>
        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Add from "./Add";
    import Edit from "./Edit";
    import {getStaffCode,getMenuButton,getChargeTime} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                dayShow:false,
                monthShow:false,
                disabledAdd:true,
                menuButtonList:null,
                th:0,
                row:null,
                showModalAdd:false,
                showModalInfo:false,
                showModalEdit:false,
                disabledEdit:true,
                disabledMonthly:true,
                dialogMonthly:false,
                tableData:null,
                monthList:[1,2,3,4,5,6,7,8,9,10,11,12],
                monthListAll:[1,2,3,4,5,6,7,8,9,10,11,12],
                monthly:['一','二','三','四','五','六','七','八','九','十','十一','十二'],
                statusValue:[[-1,'全部'],[1,'正常'],[2,'废弃']],
                status:1
            }
        },
        components:{
            Add,Edit
        },
        created(){
            if(getChargeTime()=="天"){
                this.dayShow=true;
            }else{
                this.monthShow = true;
            }
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
             getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                //this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            deWeightArr(arr){
                var c1 = this.monthListAll.filter(a=>{
                    return ! arr.some(c=>(c==a))
                })
                return c1
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InstitutionFee/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        status:this.status
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit=true;
                    this.disabledMonthly=true;
                    if(response.data.error == 0){
                        console.log(response.data);
                        this.tableData = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            monthSubmit(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InstitutionFee/AddCheckinReturnMoney",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        institutionFeeCode:this.row.institutionFeeCode,
                        returnMonth:this.deWeightArr(this.monthList)
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.dialogMonthly=false
                        this.getList()
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            toggleModalEdit(){
                this.showModalEdit = !this.showModalEdit;
                this.$refs.myEdit.init(this.row);
            },
            toggleModalMonthly(){
                this.dialogMonthly =true;
                this.monthList=this.deWeightArr(this.row.returnMonthList)
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            rowClick(row){
                 this.row = row;
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                    this.disabledMonthly =false;
                }
            }



        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
</style>
